// =============================================================================
// UUID utility
// Polyfill for crypto.randomUUID
// =============================================================================

/**
 * Generate a random UUID v4
 * Uses crypto.randomUUID if available, falls back to manual generation
 */
export function generateId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  // Manual fallback for older browsers
  // This is not cryptographically secure, but sufficient for client-side IDs
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
